export const ImageReportReason = {
  Inappropriate: 1,
  Irrelevant: 2,
  Spam: 3,
}
